function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/MultipleChoice',[],function () {
  'use strict';

  /**
   * MultipleChoice class.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-26
   * 
   * @type MultipleChoice
   */
  var MultipleChoice = /*#__PURE__*/_createClass(
  /**
   * Constructor.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @created 2021-02-26
   * 
   * @param {$} $slide
   * @param {int} iCorrect index of the correct choice
   * 
   * @returns {undefined}
   */
  function MultipleChoice() {
    var _this = this;
    _classCallCheck(this, MultipleChoice);
    /**
     * Init.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "init", function () {
      var $exerciseContainers = $(_this.o.sel.exerciseContainer);
      $exerciseContainers.each(function (iIndex, oExerciseContainer) {
        var $exerciseContainer = $(oExerciseContainer);
        if ($exerciseContainer.hasClass(_this.o.opts.classes.multipleChoice)) {
          _this.setupMultipleChoice($exerciseContainer);
        } else {
          _this.setupABChoice($exerciseContainer);
        }
      });
    });
    /**
     * Setup questions with only 2 answers.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @param {$} $exerciseContainer
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "setupABChoice", function ($exerciseContainer) {
      /* Get containers. */
      var $targetContainers = $exerciseContainer.find(_this.o.sel.targetContainer);
      var $resultContainer = $exerciseContainer.find(_this.o.sel.resultContainer);

      /* Get correct and incorrect containers. */
      var iCorrect = $exerciseContainer.find(_this.o.sel.fdbBlock).data(_this.o.opts.data.fdbNr);
      var iIncorrect = iCorrect === 0 ? 1 : 0;

      //let bClicked = false;

      /* Setup targets. */
      $targetContainers.each(function (iIndex, oTargetContainer) {
        var $targetContainer = $(oTargetContainer);
        /* Clicky. */
        $targetContainer.on('click', function (oEvent) {
          if (false === $exerciseContainer.hasClass(_this.o.opts.classes.finished)) {
            $targetContainer.addClass(_this.o.opts.classes.orderTop);

            /* On desktop exchange the target that was NOT clicked with the result container. */
            if (iCorrect === iIndex) {
              $targetContainers.eq(iIncorrect).html($resultContainer);
            } else {
              $targetContainers.eq(iCorrect).html($resultContainer);
            }

            /* Show results. */
            if (iCorrect === iIndex) {
              $exerciseContainer.find(_this.o.sel.correct).removeClass(_this.o.opts.classes.hide);
            } else {
              $exerciseContainer.find(_this.o.sel.incorrect).removeClass(_this.o.opts.classes.hide);
            }

            /* Show the result container. */
            $resultContainer.removeClass(_this.o.opts.classes.hide);
            $exerciseContainer.addClass(_this.o.opts.classes.finished);
            window.fullpage.reBuild();
          }
        });
      });
    });
    /**
     * Setup questions with 3 answers.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-26
     * 
     * @param {$} $exerciseContainer
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "setupMultipleChoice", function ($exerciseContainer) {
      var $exerciseWrapper = $exerciseContainer.parents(_this.o.sel.exerciseWrapper);
      var $startTestButton = $exerciseWrapper.find(_this.o.sel.startTestButton);
      var $contentContainer = $exerciseWrapper.find(_this.o.sel.contentContainer);
      var $testContainer = $exerciseWrapper.find(_this.o.sel.testContainer);
      var $timer = $exerciseWrapper.find(_this.o.sel.timer);

      /* Start test */
      $startTestButton.on('click', function (oEvent) {
        $contentContainer.addClass(_this.o.opts.classes.hide);
        $testContainer.removeClass(_this.o.opts.classes.hide);
        if (0 < $timer.length) {
          _this.setupTimer($timer, $exerciseContainer);
        }
        window.fullpage.reBuild();
      });
      _this.setupClickListeners($exerciseContainer);
    });
    /**
    * Setup timer.
    * 
    * @author Lennart Bergmann <lb@sopg.de>
    * @author Kai Schoenhoff <ks@sopg.de>
    * @created 2021-02-18
    * @updated 2021-03-05
    * 
    * @param {$} $timer
    * @param {$} $exerciseContainer
    * 
    * @returns {undefined}
    */
    _defineProperty(this, "setupTimer", function ($timer, $exerciseContainer) {
      var iTimeleft = 20;
      var $targetContainer = $exerciseContainer.find(_this.o.sel.targetContainer + '[data-target="3"]');
      _this.oTimer = setInterval(function () {
        if (iTimeleft <= 0) {
          clearInterval(_this.oTimer);
          $timer.text("0");
          _this.displayResults($exerciseContainer, $targetContainer.get(0), _this.o.sel.timeout);
        } else {
          $timer.text(iTimeleft);
        }
        iTimeleft -= 1;
      }, 1000);
    });
    /**
     * Setup click listeners.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-19
     * @updated 2021-02-26
     * 
     * @param {$} $exerciseContainer
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "setupClickListeners", function ($exerciseContainer) {
      var $targetContainer = $exerciseContainer.find(_this.o.sel.targetContainer);

      /* Get correct and incorrect containers. */
      var iCorrect = $exerciseContainer.find(_this.o.sel.fdbBlock).data(_this.o.opts.data.fdbNr);
      $targetContainer.each(function (iIndex, oElement) {
        $(oElement).on('click', function (oEvent) {
          /* Stop timer */
          clearInterval(_this.oTimer);
          if (false === $exerciseContainer.hasClass(_this.o.opts.classes.finished)) {
            if (iCorrect === $(oElement).data(_this.o.opts.data.target)) {
              _this.displayResults($exerciseContainer, oElement, _this.o.sel.correct);
            } else {
              _this.displayResults($exerciseContainer, oElement, _this.o.sel.incorrect);
            }
          }
        });
      });
    });
    /**
     * Display the results.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @author Kai Schoenhoff <ks@sopg.de>
     * @created 2021-02-19
     * @updated 2021-02-23
     * 
     * @param {$} $exerciseContainer
     * @param {object} oElement
     * @param {string} sResultClass
     * 
     * @returns {undefined}
     */
    _defineProperty(this, "displayResults", function ($exerciseContainer, oElement, sResultClass) {
      var $resultContainer = $exerciseContainer.parent().find(_this.o.sel.resultContainer);
      var $fdbBlocks = $resultContainer.find(_this.o.sel.fdbBlock);
      var sElementHtml = '';

      /* Show results. */
      $resultContainer.removeClass(_this.o.opts.classes.hide);
      $resultContainer.find(sResultClass).each(function (iIndex, oElement) {
        $(oElement).removeClass(_this.o.opts.classes.hide);
      });

      /* On mobile keep the clicked element on top. */
      $(oElement).addClass(_this.o.opts.classes.orderTop);

      /* Exchange targets with results, except the clicked/given one. */
      $exerciseContainer.find(_this.o.sel.targetContainer).each(function (iIndex, oTargetContainer) {
        if (oElement !== oTargetContainer) {
          $(oTargetContainer).html($fdbBlocks.splice(0, 1)[0]);
        }
      });

      /* change css for hover effects */
      $exerciseContainer.addClass(_this.o.opts.classes.finished);
      var $exerciseWrapper = $exerciseContainer.parents(_this.o.sel.exerciseWrapper);
      /* Hide stuff. */
      $exerciseWrapper.find(_this.o.sel.hideOnResults).addClass(_this.o.opts.classes.hide);

      /* Show other stuff. */
      $exerciseWrapper.find(_this.o.sel.showOnResults).removeClass(_this.o.opts.classes.hide);

      /* Rebuild scrolling. */
      window.fullpage.reBuild();
    });
    this.o = {
      sel: {
        exerciseWrapper: '.slide',
        exerciseContainer: '.exercise-container',
        targetContainer: '.dd-sc-target-container',
        resultContainer: '.sc-dd-fdb',
        targetImg: '.target-img',
        correct: '.fdb-correct',
        incorrect: '.fdb-incorrect',
        fdbBlock: '.fdb-block',
        timer: '.timer-val',
        timeout: '.fdb-timeout',
        startTestButton: '.start-test-btn',
        contentContainer: '.frst-container',
        testContainer: '.scnd-container',
        hideOnResults: '.hide-for-fdb',
        showOnResults: '.show-for-fdb'
      },
      opts: {
        classes: {
          hide: 'hide',
          multipleChoice: 'multiple-choice',
          finished: 'finished',
          orderTop: 'order-top'
        },
        data: {
          fdbNr: 'fdb-nr',
          target: 'target'
        }
      }
    };
    this.oTimer = null;
    this.init();
  });
  return MultipleChoice;
});

